import { HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable, catchError, switchMap, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { ApiErrorHelper } from '../handlers/error.handler';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private readonly authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.authService.getToken();

        if (token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                /**
                 * Não tenta refresh novamente caso a própria
                 * requisição de refresh falhe.
                 */
                if (request.url.includes('/auth/refresh')) {
                    this.authService.clearSessionAndRedirect();

                    return throwError(() => error);
                }

                /**
                 * Access token expirado/inválido.
                 *
                 * Tenta renovar utilizando o refresh_token
                 * armazenado no cookie HttpOnly.
                 */
                if (error.status === 401) {
                    return this.authService.refresh().pipe(
                        switchMap((response) => {
                            const newToken = response.accessToken;

                            const retryRequest = request.clone({
                                setHeaders: {
                                    Authorization: `Bearer ${newToken}`
                                }
                            });

                            return next.handle(retryRequest);
                        }),

                        catchError((refreshError) => {
                            this.authService.clearSessionAndRedirect();

                            return throwError(() => refreshError);
                        })
                    );
                }

                /**
                 * Outros erros continuam seguindo o comportamento
                 * atual de blacklist.
                 */
                if (token && ApiErrorHelper.isBlacklistedToken(error)) {
                    this.authService.clearSessionAndRedirect();
                }

                return throwError(() => error);
            })
        );
    }
}
